/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=66d0554a&scoped=true&"
import script from "./ForumDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./ForumDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ForumDetail.vue?vue&type=style&index=0&id=66d0554a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0554a",
  null
  
)

export default component.exports